import { createEffect } from 'effector';
import api, { ApiRequestConfig } from 'services/api';
import { PatchContactPayload } from '../../shared/types';
import api_validation, {
  ApiRequestConfig as ApiValidationRequestConfig,
} from '../../../services/api_validation';

const PATH = '/api-profile/api/v1/partner_organizations';

type FetchPartnerOrganizationProfileParams =
  | string
  | {
      uuid: string;
      suppressForbiddenNotification?: boolean;
    };

export const fetchPartnerOrganizationProfileFX = createEffect(
  async (params: FetchPartnerOrganizationProfileParams) => {
    const uuid = typeof params === 'string' ? params : params.uuid;
    const config: ApiRequestConfig = {
      suppressForbiddenNotification:
        typeof params === 'string' ? false : params.suppressForbiddenNotification,
    };
    const response = await api.get(`${PATH}/${uuid}/profile`, config);

    return response.data;
  }
);

export const confirmPartnerOrganizationProfileFX = createEffect(async (uuid: string) => {
  const response = await api.post(`${PATH}/${uuid}/profile/confirm`, {
    need_profile_review: false,
  });

  return response.data;
});

export const deletePartnerOrganizationContactFX = createEffect(
  async ({ entity_id, ...rest }: PatchContactPayload) => {
    const resp = await api.delete(`${PATH}/${entity_id}/profile/contacts`, {
      params: rest,
    });

    return resp.data;
  }
);

export const partnerOrganizationProfileIsActive = createEffect(
  async ({
    uuid,
    suppressForbiddenNotification = true,
  }: {
    uuid: string;
    suppressForbiddenNotification?: boolean;
  }) => {
    const config: ApiValidationRequestConfig = { suppressForbiddenNotification };
    const response = await api_validation.get(`${PATH}/${uuid}/profile`, config);

    return response.data;
  }
);
